import { type Subscription, StripeStatus } from './Subscription.types';

export function subscriptionIncomplete(subscription: Subscription | null | undefined) {
    return subscription?.stripeStatus === StripeStatus.incomplete;
}

export function subscriptionPastDue(subscription: Subscription | null | undefined) {
    return subscription?.stripeStatus === StripeStatus.pastDue;
}
